/**
 * 把后端 API 错误翻译为当前 locale 的友好文案。
 *
 * 规则：
 * 1. 如果 err.code 存在且 rm.errorCodes 字典里有对应翻译 → 使用翻译
 * 2. 否则 fallback 到 err.message（后端写的英文 fallback）
 * 3. 再不行就返回 undefined，让调用方用自己的默认文案
 *
 * 对应后端：throw new BadRequestException({ code: RobotError.XXX, message: '...' })
 * → response.error.code === 'ROBOT_XXX' → ApiClientError.code
 */
export function translateApiError(err: unknown, rm: { errorCodes: Record<string, string> }): string | undefined {
  if (!err || typeof err !== 'object') return undefined;
  const anyErr = err as { code?: string; message?: string };
  if (anyErr.code && rm.errorCodes?.[anyErr.code]) {
    return rm.errorCodes[anyErr.code];
  }
  return anyErr.message || undefined;
}
